// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_j4-0";
export var discountCodeInput = "_j4-1";